import React from "react";

import Banner from "./Banner"; 
import PopularTours from "./PopularTours";
import HomeTestimonials from "./HomeTestimonials";
//  import Services from "./Services";
import WhyChoose from "./WhyChoose";
import OurServices from "./OurServices";
import OurCars from "./OurCars";
import VaranasiTours from "./VaranasiTours";

export default function Home() {
  return (
    <div>
      <Banner />
      <OurCars /> 
      <VaranasiTours />
      <OurServices />
      <PopularTours />
      <HomeTestimonials />
       <WhyChoose/>
    </div>
  );
}
